import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/Dialog';
import { DialogHeader, DialogFooter } from '@/components/ui/Dialog';
import { useRemovePrompt } from '@/hooks/useRemovePrompts';
import { Prompt, FilterPromptsDto } from '@/services/PromptsService';

interface RemovePromptDialogProps {
  open: boolean;
  onClose: () => void;
  prompt: Prompt;
  filter: FilterPromptsDto;
}

export function RemovePromptDialog({
  open,
  onClose,
  prompt,
  filter,
}: RemovePromptDialogProps) {
  const { removePrompt, isRemoving } = useRemovePrompt(filter);

  const handleDelete = async () => {
    try {
      await removePrompt(prompt.id || '');
      toast.success('Prompt removed successfully!');
      onClose();
    } catch (error) {
      toast.error('Failed to remove prompt. Please try again.');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm deletion</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the prompt &quot;{prompt.promptName}
            &quot;? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isRemoving}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isRemoving}
          >
            {isRemoving ? 'Removing...' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
